import * as React from 'react';

export default function DollarPlain(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M13.332 7.083H15c0-2.364-2.296-3.442-4.167-3.69V1.667H9.166v1.726c-1.871.248-4.167 1.326-4.167 3.69 0 2.255 2.222 3.428 4.167 3.692v4.142c-1.207-.21-2.5-.854-2.5-2H4.999c0 2.157 2.02 3.432 4.167 3.696v1.72h1.666v-1.725C12.703 16.36 15 15.281 15 12.917s-2.296-3.443-4.167-3.691V5.083c1.109.2 2.5.785 2.5 2Zm-6.666 0c0-1.215 1.391-1.8 2.5-2v4c-1.143-.211-2.5-.835-2.5-2Zm6.666 5.834c0 1.216-1.391 1.8-2.5 2v-4c1.109.199 2.5.784 2.5 2Z"
      />
    </svg>
  );
}
